export default __webpack_public_path__ + "static/media/blueCamera.f257e113.svg";